var map = {
	"./acompanhante_hospitalar.svg": 5915,
	"./adestrador_caes.svg": 6074,
	"./adestrador_de_caes.svg": 6414,
	"./animador_de_festas.svg": 3098,
	"./ar_condicionado.svg": 1414,
	"./aulas_de_informatica.svg": 4514,
	"./aulas_de_ingles.svg": 5181,
	"./aulas_de_musica.svg": 7243,
	"./aulas_de_reforco_escolar.svg": 2567,
	"./aulas_particulares.svg": 6118,
	"./azulejista.svg": 2708,
	"./baba.svg": 2290,
	"./banho_e_tosa.svg": 5210,
	"./banho_tosa.svg": 9574,
	"./barbeiro.svg": 6510,
	"./borracharia.svg": 2842,
	"./buffet.svg": 8066,
	"./cabeleireiroa.svg": 3899,
	"./cerimonialista.svg": 7328,
	"./chaveiro.svg": 4642,
	"./churrasqueiro.svg": 6461,
	"./conserto_de_forno_eletrico.svg": 2576,
	"./conserto_de_micro_ondas.svg": 2150,
	"./cuidador_de_idosos.svg": 3215,
	"./cuidador_de_pessoas.svg": 1474,
	"./cuidador_idosos.svg": 4587,
	"./decoracao_de_festas.svg": 794,
	"./decoracao_festas.svg": 6806,
	"./dedetizador.svg": 5627,
	"./designer_de_sobrancelhas.svg": 919,
	"./diarista.svg": 251,
	"./dj.svg": 9960,
	"./dog_walker.svg": 8717,
	"./eletricista.svg": 9517,
	"./eletronica_cameras.svg": 173,
	"./encanador.svg": 3675,
	"./faxina.svg": 8831,
	"./faxineiroa.svg": 5466,
	"./filmagem_de_eventos.svg": 8547,
	"./fisioterapeuta.svg": 8677,
	"./fotografo.svg": 857,
	"./frete.svg": 9430,
	"./frete_e_carreto.svg": 597,
	"./funileiro.svg": 5165,
	"./garcom.svg": 4863,
	"./gesseiro.svg": 243,
	"./impermeabilizacao.svg": 860,
	"./instalacao_de_alarmes.svg": 1683,
	"./instalacao_de_antena.svg": 9215,
	"./instalacao_de_ar_condicionado.svg": 2608,
	"./instalacao_de_cameras.svg": 1276,
	"./instalacao_de_cortinas_e_persianas.svg": 9252,
	"./instalacao_de_tv_na_parede.svg": 9134,
	"./instalacao_de_ventilador_de_teto.svg": 7546,
	"./instalador_de_drywall.svg": 6767,
	"./instalador_de_papel_de_parede.svg": 66,
	"./instalador_de_piso_laminado.svg": 9601,
	"./jardineiro.svg": 6841,
	"./jardineiroa.svg": 4858,
	"./lavagem_carros.svg": 8286,
	"./lavagem_de_caixa_dagua.svg": 9467,
	"./lavagem_de_carros.svg": 7138,
	"./limpeza_de_colchao.svg": 9070,
	"./limpeza_de_piscina.svg": 3182,
	"./limpeza_de_sofa.svg": 762,
	"./limpeza_piscina.svg": 2480,
	"./limpeza_pos_obra.svg": 6096,
	"./manicure.svg": 2208,
	"./manicure_e_pedicure.svg": 5520,
	"./manutencao_de_geladeira.svg": 6032,
	"./manutencao_de_maquina_de_lavar.svg": 6251,
	"./maquiadora.svg": 7212,
	"./marceneiro.svg": 3915,
	"./marido_de_aluguel.svg": 5752,
	"./massagista.svg": 375,
	"./mecanico_automotivo.svg": 6637,
	"./montador_de_moveis.svg": 622,
	"./montador_moveis.svg": 4620,
	"./montagem_e_desmontagem_para_mudanca.svg": 6870,
	"./mudanca.svg": 3953,
	"./mudancas_residenciais.svg": 8890,
	"./passadeirao.svg": 2794,
	"./passeador_de_caes.svg": 6103,
	"./pedreiro.svg": 3914,
	"./personal_trainer.svg": 8980,
	"./pet_sitter.svg": 1973,
	"./pintor.svg": 5898,
	"./polimento_automotivo.svg": 7859,
	"./professor_ingles.svg": 2164,
	"./professor_particular.svg": 3065,
	"./serralheiro.svg": 672,
	"./suporte_de_redes.svg": 7666,
	"./tecnico_em_ar_condicionado.svg": 3249,
	"./tecnico_em_informatica.svg": 2036,
	"./tecnico_informatica.svg": 2983,
	"./telhadista.svg": 2265,
	"./troca_de_bateria.svg": 3360,
	"./vidraceiro.svg": 9448
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5296;